import React, { Component } from 'react';
import BulletRecoveryPayment from './BulletRecovery.container';
import EmiRecoveryPayment from './EmiRecovery.container';
import Vreedhiui from './VreedhiEmiRecovery.container'

class RecoveryContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            RecoveryPageToShow: 'bullet',
            collectionType: 'recovery'
        }
    }

    render() {
        const { admin } = this.props
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xs-12 recovery-tabs">
                        <div className="dashboard-tabs" style={{width:'100px'}}>
                        {/* <div className="dashboard-tabs" style={{width:'174px'}}> */}
                            <button style={{padding:'1px 6px'}} className={this.state.RecoveryPageToShow == 'bullet' ? 'active' : ''} onClick={e => this.buttonActionHandler("bullet")}>Bullet</button>
                            <button style={{padding:'1px 6px'}} className={this.state.RecoveryPageToShow == 'emi' ? 'active' : ''} onClick={e => this.buttonActionHandler("emi")}>Emi</button>
                            {/* <button className={this.state.RecoveryPageToShow == 'vreedhi' ? 'active' : ''} onClick={e => this.buttonActionHandler("vreedhi")}>Vreedhi</button> */}

                        </div>
                    </div>
                </div>
                {this.state.RecoveryPageToShow == 'bullet' ?
                    <BulletRecoveryPayment
                        admin={admin}
                        collectionType={this.state.collectionType} />
                    : this.state.RecoveryPageToShow == 'emi' ?
                        <EmiRecoveryPayment
                            admin={admin}
                            collectionType={this.state.collectionType} />
                            : this.state.RecoveryPageToShow == 'vreedhi' ?
                            <Vreedhiui
                                admin={admin}
                                collectionType={this.state.collectionType} />
                        : null}
            </div>
        )
    }

    buttonActionHandler(type) {
        this.setState({
            RecoveryPageToShow: type
        })
    }

}


export default RecoveryContainer;